import { useAverageCompletionTimes } from "../useAverageCompletionTimes"

const { dates, averageDurationsSeries, calculateAverageCompletionTimes } = useAverageCompletionTimes()

export const averageCompletionDataProcessor = (jobsData) => {
  calculateAverageCompletionTimes(jobsData)
  return {
    series: averageDurationsSeries.value,
    categories: dates.value
  }
}